import styled from "styled-components";

export default styled.h2`
  margin-top: 96px;
`;
